<div class="dynamic-button-container">
  <h3>Autentique Button 'Generator'</h3>

  <div class="button-generator-layout">
    <div class="button-options">
      <!-- Button Type Selector -->
      <div class="button-option">
        <label for="buttonType">Button Type:</label>
        <select id="buttonType" [(ngModel)]="buttonType" (change)="updateButton()">
          <option value="btn-filled">Filled</option>
          <option value="btn-outline">Outline</option>
          <option value="btn-text">Text</option>
        </select>
      </div>

      <!-- Button Type Variant -->
      <div class="button-option">
        <label for="buttonTypeVariant">Button Type Variant:</label>
        <select id="buttonTypeVariant" [(ngModel)]="buttonTypeVariant" (change)="updateButton()">
          <option value="">No Variant</option>
          @switch (buttonType) {
            @case ('btn-filled') {
              <option value="btn-filled-danger">Filled Danger</option>
              <option value="btn-filled-cancel">Filled Cancel</option>
              <option value="btn-filled-alt">Filled Alt</option>
            }
            @case ('btn-text') {
              <option value="btn-text-danger">Text Danger</option>
              <option value="btn-text-cancel">Text Cancel</option>
            }
            @case ('btn-outline') {
              <option value="btn-outline-danger">Outline Danger</option>
              <option value="btn-outline-premium">Outline Premium</option>
              <option value="btn-outline-neutral">Outline Neutral</option>
            }
          }
        </select>
      </div>

      <!-- Button State Selector -->
      <div class="button-option">
        <label for="buttonState">State:</label>
        <select id="buttonState" [(ngModel)]="buttonState" (change)="updateButton()">
          <option value="">Default</option>
          <option value="state-hover">Hover</option>
          <option value="state-focus">Focus</option>
          <option value="state-active">Active</option>
          <option value="state-disabled">Disabled</option>
        </select>
      </div>

      <!-- Button Size Selector -->
      <div class="button-option">
        <label for="buttonSize">Size:</label>
        <select id="buttonSize" [(ngModel)]="buttonSize" (change)="updateButton()">
          <option value="btn-L">Large</option>
          <option value="btn-M">Medium</option>
          <option value="btn-S">Small</option>
          <option value="btn-XS">Extra Small</option>
        </select>
      </div>

      <!-- Start Icon Selector -->
      <div class="button-option">
        <label for="iconStart">Start Icon:</label>
        <select id="iconStart" [(ngModel)]="iconStart" (change)="updateButton()">
          <option value="">No Icon</option>
          <option value="far fa-plus">Plus</option>
          <option value="far fa-check">Check</option>
          <option value="far fa-times">Times</option>
        </select>
      </div>

      <!-- End Icon Selector -->
      <div class="button-option">
        <label for="iconEnd">End Icon:</label>
        <select id="iconEnd" [(ngModel)]="iconEnd" (change)="updateButton()">
          <option value="">No Icon</option>
          <option value="far fa-plus">Plus</option>
          <option value="far fa-check">Check</option>
          <option value="far fa-times">Times</option>
        </select>
      </div>

      <!-- Show or Hide Text -->
      <div class="button-option button-option--checkbox">
        <label for="hasText">Include Text:</label>
        <input type="checkbox" id="hasText" [(ngModel)]="hasText" (change)="updateButton()" />
      </div>
    </div>

    <!-- Dynamic Button -->
    <div class="button-preview">
      <button [class]="buttonClassShow" [disabled]="isDisabled">
        @if (iconStart) {
          <i [class]="iconStart"></i>
        }
        @if (hasText) {
          <span>Label</span>
        }
        @if (iconEnd) {
          <i [class]="iconEnd"></i>
        }
      </button>
    </div>
  </div>

  <!-- Button Class Display -->
  <div class="value">
    <input class="value-show" readonly="" [value]="buttonClass" type="text" #inputValue />
    <a class="value-copy text-decoration-none" [ngxClipboard]="inputValue"></a>
  </div>
</div>
